<p-skeleton [width]="width" [height]="height"></p-skeleton>
